/**
 * 指定位置までスクロールする関数
 */
function $scrollAnimation(selector){
	var position = 0;
	if(selector !== "#"){
		var $target = $(selector);
		if($target.length !== 0){
			var position = $target.offset().top - 20; //ターゲット位置を取得
			var $header = $('#globalHeader'); //ヘッダー取得
			if($header.length !== 0 && $header.css('display') !== 'none'){ //ヘッダー分位置をずらす
				position = position - $header.outerHeight();
			}
		}
	}
	$("html,body").animate({scrollTop:position},500); //ターゲット位置までscroll
}

/**
 * ページ内リンククリック時にスクロールアニメーションさせる。
 */
$(document).on('click','a[href^="#"]',function(){
	const selector = $(this).attr('href');
	const lazyLoadImages = document.querySelectorAll(".js-lazy-load");
	let loadTime = 0;

	//位置がズレるので、遅延読み込みのimgを強制的に読み込む
	if(lazyLoadImages.length > 0){
		lazyLoadImages.forEach((img) => {
			img.src = img.dataset.src;
		});
		loadTime = 300;
	}
	setTimeout(() => {
		$scrollAnimation(selector);
	}, loadTime); 
	
	return false;
});
